export default "__VITE_ASSET__4f701a53__"